import { Link } from 'react-router-dom';
import { categories } from '@/mocks/resources';

export default function CategorySection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            资源分类
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            六大精选分类，涵盖学习、办公、设计、工具等多个领域
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-accent-100 text-accent-600 group-hover:bg-primary-100 group-hover:text-primary-600 transition-all duration-300 mb-3">
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-sm font-bold text-foreground-800 group-hover:text-primary-600 transition-colors duration-200 mb-1 whitespace-nowrap">
                {cat.name}
              </h3>
              <span className="text-xs text-foreground-400">
                {cat.count.toLocaleString()} 份
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}